/** The project page's Book a Meeting copy, kept while the flat settings decide. */
export const BOOK_A_MEETING = 'Book a Meeting';
